import { Module } from "vuex";
import { RootState } from "../types";
import { AnalyticsInt } from "./types";
import { getters } from "./getter";
import { actions } from "./actions";
import { mutations } from "./mutations";

const state = {
  error: "",
  data: {},
} as AnalyticsInt;

export const analytics: Module<AnalyticsInt, RootState> = {
  state,
  getters,
  actions,
  mutations,
};
